import React, {useState} from 'react';
import Navbar from './Navbar';
import {Link, NavLink} from 'react-router-dom';
import '../App.css';
import './FoundationContact.css';
import FoundationNavBar from './FoundationNavBar';
import Container from '@material-ui/core/Container';
import mailData from '../data/mailData.js';

function FoundationContact() {
    return (
        <>
        <div className="foundation-container main-container" id="contact-box">
            <title>Foundation - Contact</title>
            <h1 className="sr-only" tabIndex={0}>Foundation - Contact</h1>
            <img src="/images/contact-us-banner.jpg" className="banner-img" alt=''/>
            <FoundationNavBar/>
        </div>
        <Container className='contact-box' id="main">
            <h2>For learning related queries reach out to: <br/> 
            <span><a href={`mailto:${mailData.lttfoundationAssessment}`}>L-TT.FoundationAssessment</a></span>
            </h2>
        </Container>

        </>
    )
}

export default FoundationContact;

